import React from "react";
import { Box, Card, Typography } from "@mui/material";
import useFetchWithAuth from "../../../features/hooks/useFetchWithAuth";

const formatDate = (date) => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

const OperatorStats = () => {
  const dateStr = formatDate(new Date());
  const { data, loading, error } = useFetchWithAuth(
    `/statistic/operator/metrics/${dateStr}/`
  );

  const stats = data?.personal_details ?? {};
  const averageCheck = stats.average_check ?? 0;
  const upsellPercent = stats.percent_upsell ?? 0;
  const leadsPerHour = stats.leads_per_hour ?? 0;

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <Card
      sx={{
        background: "var(--whiteColor)",
        borderRadius: 3,
        p: 3,
        boxShadow: "none",
      }}
    >
      <Typography
        sx={{
          color: "var(--blackColor)",
          fontWeight: 700,
          fontSize: 16,
          mb: 2,
          ".dark-theme &": { color: "var(--whiteColor)" },
        }}
      >
        Ваші показники за сьогодні
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography sx={{ color: "var(--bodyColor)" }}>
            Середній чек
          </Typography>
          <Typography sx={{ color: "var(--blackColor)", fontWeight: 600 }}>
            {averageCheck}₴
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography sx={{ color: "var(--bodyColor)" }}>% допродажу</Typography>
          <Typography sx={{ color: "var(--blackColor)", fontWeight: 600 }}>
            {upsellPercent}%
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography sx={{ color: "var(--bodyColor)" }}>Лідів/год</Typography>
          <Typography sx={{ color: "var(--blackColor)", fontWeight: 600 }}>
            {leadsPerHour}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};

export default OperatorStats;
